module.exports = __webpack_public_path__ + "img/Rocket ship Icon - charcoal.2e5a2517.svg";